import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/home.vue'
import ColabFoodLogin from '../views/services/colab-food/ColabFoodLogin.vue'
import ColabFoodHome from '../views/services/colab-food/views/colabFoodHome.vue'
import ColabFoodPerfil from '../views/services/colab-food/views/colabFoodPerfil.vue'
import ColabFoodProdutos from '../views/services/colab-food/views/colabFoodProdutos.vue'
import ColabFoodVendas from '../views/services/colab-food/views/colabFoodVendas.vue'
import ColabFoodLoginAdm from '../views/services/colab-food/ColabFoodLoginAdm.vue'
import ColabFoodFaturamento from '../views/services/colab-food/views/colabFoodFaturamento.vue'
import ColabFoodAdmHome from '../views/services/colab-food/admpages/colabFoodAdmHome.vue'

const routes = [
  //Luiz Trindade - Rota da landing page
  {
    path: '/',
    name: 'home',
    component: Home
  },
  //---------------------------------------------

  //Luiz Trindade - Rotas do serviço "Colab-Food"
  {
    path: '/services/colab-food/',
    name: 'ColabFoodLogin',
    component: ColabFoodLogin
  },
  {
    path: '/services/colab-food/adm',
    name: 'ColabFoodLoginAdm',
    component: ColabFoodLoginAdm
  },
  {
    path: '/services/colab-food/admpages/homeadm',
    name: 'ColabFoodAdmHome',
    component: ColabFoodAdmHome
  },
  {
    path: '/services/colab-food/views/home',
    name: 'colabFoodHome',
    component: ColabFoodHome
  },
  {
    path: '/services/colab-food/views/perfil',
    name: 'colabFoodPerfil',
    component: ColabFoodPerfil
  },
  {
    path: '/services/colab-food/views/produtos',
    name: 'colabFoodProdutos',
    component: ColabFoodProdutos
  },
  {
    path: '/services/colab-food/views/vendas',
    name: 'colabFoodVendas',
    component: ColabFoodVendas
  },
  {
    path: '/services/colab-food/views/faturamento',
    name: 'colabFoodFaturamento',
    component: ColabFoodFaturamento
  },
  //----------------------------------------------
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
